var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-md-12 quote-history" },
    [
      _vm.formState == "sending" || _vm.loading
        ? _c("div", { attrs: { id: "sending" } }, [
            _c("div", { staticClass: "overlay" }),
            _vm._v(" "),
            _c("div", { staticClass: "form-sending" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.history, function (entry) {
        return _c("div", { key: entry.id, staticClass: "row mt-md-2 mt-3" }, [
          entry.senderType.slug == "client"
            ? _c("div", { staticClass: "col-md-9 message from-client" }, [
                _c("div", { staticClass: "row align-self-start" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-2 quote_message__section" },
                    [
                      _c("span", { staticClass: "client__name" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(entry.clientContact.name) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(entry.added.locale.date) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-9 quote_message__section align-self-center",
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "span",
                            { staticClass: "status", class: entry.status.code },
                            [
                              _vm._v(
                                "Tila: " + _vm._s(entry.status.locale.name)
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("transition-collapse-height", [
                        _vm.isMessageVisible(entry.id)
                          ? _c(
                              "div",
                              { staticClass: "row collapsible-message" },
                              [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(entry.message) +
                                      "\n                            "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      key: _vm.rerenderToggles,
                      staticClass:
                        "col-md-1 history-toggle quote_message__section align-self-center",
                    },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.isMessageVisible(entry.id)
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.closeMessage(entry.id)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-arrow-alt-circle-up arrow-icon--client arrow-icon",
                                }),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openMessage(entry.id)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-arrow-alt-circle-down arrow-icon--client arrow-icon",
                                }),
                              ]
                            ),
                      ]),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          entry.senderType.slug == "client"
            ? _c("div", { staticClass: "col-md-2" })
            : _vm._e(),
          _vm._v(" "),
          entry.senderType.slug == "user"
            ? _c("div", { staticClass: "col-md-2" })
            : _vm._e(),
          _vm._v(" "),
          entry.senderType.slug == "system"
            ? _c("div", { staticClass: "col-md-2" })
            : _vm._e(),
          _vm._v(" "),
          entry.senderType.slug == "user"
            ? _c("div", { staticClass: "col-md-9 message from-band" }, [
                _c("div", { staticClass: "row align-self-start" }, [
                  _c(
                    "div",
                    {
                      key: _vm.rerenderToggles,
                      staticClass:
                        "col-md-1 history-toggle order-3 order-md-1 quote_message__section align-self-center",
                    },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.isMessageVisible(entry.id)
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.closeMessage(entry.id)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas arrow-icon arrow-icon--band fa-arrow-alt-circle-up",
                                }),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openMessage(entry.id)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas arrow-icon arrow-icon--band fa-arrow-alt-circle-down",
                                }),
                              ]
                            ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-9 order-2 order-md-2 quote_message__section align-self-center",
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-8" }, [
                          _c(
                            "span",
                            { staticClass: "status", class: entry.status.code },
                            [
                              _vm._v(
                                "Tila: " + _vm._s(entry.status.locale.name)
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("transition-collapse-height", [
                        _vm.isMessageVisible(entry.id)
                          ? _c(
                              "div",
                              { staticClass: "row collapsible-message" },
                              [
                                _c("div", { staticClass: "col-md-10" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(entry.message) +
                                      "\n                            "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-2 order-1 order-md-3 quote_message__section",
                    },
                    [
                      _c("span", { staticClass: "client__name" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(entry.user.givenName) +
                            " " +
                            _vm._s(entry.user.familyName) +
                            "\n                    "
                        ),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(entry.added.locale.date) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          entry.senderType.slug == "system"
            ? _c("div", { staticClass: "col-md-9 message from-system" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c(
                    "div",
                    {
                      key: _vm.rerenderToggles,
                      staticClass:
                        "col-md-1 history-toggle order-3 order-md-1 quote_message__section",
                    },
                    [
                      _c("transition", { attrs: { name: "fade" } }, [
                        _vm.isMessageVisible(entry.id)
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.closeMessage(entry.id)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-arrow-alt-circle-up arrow-icon arrow-icon--system",
                                }),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openMessage(entry.id)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fas fa-arrow-alt-circle-down arrow-icon arrow-icon--system",
                                }),
                              ]
                            ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-9 order-2 order-md-2 quote_message__section",
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-8" }, [
                          _c(
                            "span",
                            { staticClass: "status", class: entry.status.code },
                            [
                              _vm._v(
                                "Tila: " + _vm._s(entry.status.locale.name)
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("transition-collapse-height", [
                        _vm.isMessageVisible(entry.id)
                          ? _c(
                              "div",
                              { staticClass: "row collapsible-message" },
                              [
                                _c("div", { staticClass: "col-md-10" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(entry.message) +
                                      "\n                            "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-2 order-1 order-md-3 quote_message__section",
                    },
                    [
                      _c("span", { staticClass: "client__name" }, [
                        _vm._v(
                          "\n                        Buukkaa-bandi.fi\n                    "
                        ),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(entry.added.locale.date) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.quote != null
            ? _c("quote-reply", {
                attrs: {
                  id: _vm.id,
                  checksum: _vm.checksum,
                  quote: _vm.quote,
                  history: _vm.history,
                  turnDownOptions: _vm.turnDownOptions,
                  "has-contract": _vm.hasContract,
                },
                on: {
                  formsent: function ($event) {
                    return _vm.reloadHistory(true)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("hr", { staticClass: "row" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }